// Pinia Store
import { defineStore } from 'pinia';
import { useNuxtApp } from 'nuxt/app';
import { ref } from 'vue';
import type { ResponseDataDealer } from '~~/common/types/api';
import { setErrorNotification } from '~~/common/utils/helper';

type ActualMessagesResponse = ResponseDataDealer<'/api/v2/dealer/actual_messages', 'get'>;

export const useDealerNotificationStore = defineStore('dealerNotification', () => {
  const nuxtApp = useNuxtApp();


  const notifications = ref<ActualMessagesResponse>([]);

  const modalsFinished = ref(true);

  async function fetchNotifications () {
    const {
      $api,
      $logger,
    } = nuxtApp;
    try {
      const result = await $api.$get<ActualMessagesResponse>('/dealer/actual_messages');
      if (Array.isArray(result)) {
        notifications.value = result;
      } else {
        $logger.warn('dealer/actual_messages is not an array');
      }
      modalsFinished.value = false;
    } catch (error) {
      $logger.error(error);
      setErrorNotification({ nuxtApp, error });
    }
  }

  function finishModals () {
    modalsFinished.value = true;
  }

  return {
    notifications,
    modalsFinished,
    finishModals,
    fetchNotifications,
  };
});
